var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vCenter read"},[_c('img',{attrs:{"src":"/img/icon/read.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("\n    "+_vm._s(_vm.readcount)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4fa4afa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/readcount/um-readcount.vue
// module id = 102
// module chunks = 0